module.exports = __webpack_public_path__ + "static/media/logo-small.335e046c.png";